import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function Table(_ref) {
  var {
    children,
    node
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "prezly-slate-table-container",
    children: /*#__PURE__*/_jsx("table", {
      className: classNames('prezly-slate-table', {
        'prezly-slate-table--withBorders': node.border
      }),
      children: /*#__PURE__*/_jsx("tbody", {
        children: children
      })
    })
  });
}